import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Role } from '../models/role';
import { AuthService } from '../services/auth.service';
import { getUserOnSessionStorage } from 'app/shared/functions/functions';

@Injectable({
  providedIn: 'root'
})
export class MemberGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router, private activatedRoute: ActivatedRoute) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const targetRoute = route.children[0].routeConfig.path;
    const currentUser = this.auth.currentUserValue;
    const previousUrl = sessionStorage.getItem('previousUrl');
    let landingPage = "/main-page";

    if(previousUrl && previousUrl.includes('/admin')) {
      landingPage = "/auth/login/admin";
    }

    if (currentUser && this.auth.isAuthenticated) {
      if (currentUser.roles[0] !== Role.Basic) {
        this.router.navigate(['/error/unauthorized']);
        return false;
      }

      const isPrivileged = getUserOnSessionStorage('isPrivileged');
      if(isPrivileged && !targetRoute.includes('gam')) {
        this.router.navigate(['/error/unauthorized']);
      }
      
      return true;
    }
   
    this.auth.clearSession();
    if(targetRoute == '**'){
      this.router.navigate([landingPage]);
    }else{
      this.router.navigate(['/error/unauthorized']);
    }
    
    return false;
  }
  
}
